export default __webpack_public_path__ + "static/media/dmt.4b2a203b.svg";